<template>
    <div>
        <section class="flex flex-col w-full">
            <h1 class="w-full p-2 bg-aitems-700 text-gray-100 font-light tracking-wide">
                {{ trans.get('items.lista_articoli') }}
            </h1>
            <div class="flex w-full p-4 justify-between">
                <div class="relative w-1/5">
                    <select class="w-full block appearance-none bg-gray-100 border-b rounded-none border-gray-700 text-gray-700 px-4 py-2 pr-8"
                            v-model="itemsFilter"
                            @change="filter(true)"
                    >
                        <option value="" selected>{{ trans.get('items.filtro_tutti') }}</option>
                        <option :value="itemType.classe_e" v-for="itemType in itemTypes"
                                v-text="itemType.p_r_classe_e"></option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                        </svg>
                    </div>
                </div>
                <open-modal modal="add-items">
                    {{ trans.get('items.aggiungi_articolo') }}
                </open-modal>
            </div>
        </section>

        <section class="w-3/4 table mx-auto rounded border shadow-lg">
            <div class="th tr">
                <div class="td">
                    {{ trans.get('items.cod_articolo') }}
                    <div class="flex flex-col justify-between pr-2 cursor-pointer">
                        <div @click="sortTheTable('string', 'id_articolo', true)">
                            <i class="fas fa-caret-up"></i>
                        </div>
                        <div @click="sortTheTable('string', 'id_articolo')">
                            <i class="fas fa-caret-down"></i>
                        </div>
                    </div>
                </div>
                <div class="td" style="flex-grow: 2">
                    {{ trans.get('items.descrizione') }}
                    <div class="flex flex-col justify-between pr-2 cursor-pointer">
                        <div @click="sortTheTable('string', 'descrizione', true)">
                            <i class="fas fa-caret-up"></i>
                        </div>
                        <div @click="sortTheTable('string', 'descrizione')">
                            <i class="fas fa-caret-down"></i>
                        </div>
                    </div>
                </div>
                <div class="td" style="flex-grow: 2">
                    {{ trans.get('items.descrizione_ridotta') }}
                    <div class="flex flex-col justify-between pr-2 cursor-pointer">
                        <div @click="sortTheTable('string', 'descrizione_ridotta', true)">
                            <i class="fas fa-caret-up"></i>
                        </div>
                        <div @click="sortTheTable('string', 'descrizione_ridotta')">
                            <i class="fas fa-caret-down"></i>
                        </div>
                    </div>
                </div>
                <div class="td">
                    {{ trans.get('items.tipo_parte')}}
                    <div class="flex flex-col justify-between pr-2 cursor-pointer">
                        <div @click="sortTheTable('string', 'p_r_classe_e', true)">
                            <i class="fas fa-caret-up"></i>
                        </div>
                        <div @click="sortTheTable('string', 'p_r_classe_e')">
                            <i class="fas fa-caret-down"></i>
                        </div>
                    </div>
                </div>
                <div class="td"><i class="far fa-edit"></i></div>
            </div>
            <section>
                <div class="row"
                     v-for="(item, index) in table.items"
                     :key="item.id"
                >
                    <item :dataset="item" @item_has_been_deleted="remove(index)">
                        <div class="tr" slot-scope="{item, url, destroy, onDataHasChanged}">
                            <div class="td uppercase">
                                <editable-cell-input :id="item.id_articolo"
                                                     :data="item.id_articolo"
                                                     :field="'id_articolo'"
                                                     :url="url"
                                                     @data-has-changed="onDataHasChanged"
                                >
                                </editable-cell-input>
                            </div>
                            <div class="td" style="flex-grow: 2">
                                <editable-cell-input :id="item.id_articolo"
                                                     :data="item.descrizione"
                                                     :field="'descrizione'"
                                                     :url="url"
                                                     @data-has-changed="onDataHasChanged"
                                >
                                </editable-cell-input>
                            </div>
                            <div class="td" style="flex-grow: 2">
                                <editable-cell-input :id="item.id_articolo"
                                                     :data="item.descrizione_ridotta"
                                                     :field="'descrizione_ridotta'"
                                                     :url="url"
                                >
                                </editable-cell-input>
                            </div>
                            <div class="td">{{ item.p_r_classe_e }}</div>
                            <div class="td justify-start">
                                <span class="px-2 w-1/3 cursor-pointer" @click="destroy(item)">
			                        <i class="fa fa-trash"></i>
                                </span>
                                <a :href="'/items/' + item.id_articolo + '/fixing'" class="px-2 w-1/3">
                                    <i class="fas fa-thumbtack"></i>
                                </a>
                                <span v-if="item.is_fixed" class="px-2 w-1/3" v-tooltip="'Wow! Esiste un fissaggio'">
                                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                    </item>
                </div>
            </section>
            <div class="flex justify-center py-2 items-center">
                <paginate :pagination="pagination" @paginate="filter" :offset="4"></paginate>
            </div>
        </section>


        <modal name="add-items" height="auto" transition="slide" :clickToClose="false">
            <div class="flex flex-col">

                <div class="w-full flex justify-between items-center py-3 px-1 bg-aitems-700 text-gray-100 mb-6">
                    <div class="font-bold tracking-wide p-2 pl-6 uppercase">{{ trans.get('items.aggiungi_articolo_header') }}</div>
                    <div class="font-bold p-2 cursor-pointer"
                         @click="$modal.hide('add-items')">
                        <i class="fas fa-times-circle"></i>
                    </div>
                </div>

                <item-creator @item-has-been-created="onItemCreated"></item-creator>

            </div>
        </modal>

    </div>
</template>

<script>

    import ItemCreator from './ItemCreator.vue';
    import Item from './Item.vue';
    import EditableCellInput from './EditableCellInput';
    import openModal from './buttons/openModal';
    import Paginate from "./utilities/Paginate";

    export default {

        data() {
            return {
                table: new Table({
                    items: '',
                }),
                isActive: false,
                itemTypes: '',
                itemsFilter: '',
                pagination: {},
            }
        },

        components: {
            ItemCreator,
            Item,
            EditableCellInput,
            openModal,
            Paginate
        },

        created() {
            this.filter();
            this.fetchItemTypes();
        },

        methods: {
            fetchItemTypes() {
                axios.get('/item_types?original')
                    .then((response) => this.itemTypes = response.data);
            },

            filter(changed = false) {
                let current_page;

                if (!changed) {
                    current_page = this.pagination.current_page;
                }

                let pageNum = current_page ? current_page : 1;

                axios.get(`/items?type=${this.itemsFilter}&paginate=25&page=${pageNum}`)
                    .then(({data}) => {
                        this.table.items = data.data.items;
                        this.pagination = data.data.pagination;
                    });
            },

            toggleItemCreator() {
                this.isActive = !this.isActive;
            },

            onItemCreated(item) {
                console.log('Cucu');
                this.table.items.push(item);
            },

            sortTheTable(mode, key, reverse = false) {

                if (mode == 'string') {
                    return this.table.sortByString('items', key, reverse);
                }
                this.table.sortByValue('items', key, reverse);

            },

            remove(index) {
                this.table.items.splice(index, 1);
            },

//            deleteItem(item) {
//                this.table.destroy('items', item);
//            },

            resetTable() {
                this.table.fetch('/items', 'items'); //PORCATA!
            },
        }

    }
</script>

